import React, { useState, useEffect } from "react";
import {OverlayTrigger, Tooltip, Row, Col, Container, Card, Button, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../CommonCSS/SocietyCSS.css";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const KPI_Master = () => {

  const [isEditable, setIsEditable] = useState(false);
  const [genMasters, setGenMasters] = useState([]);

  const [kpiRows, setKpiRows] = useState([
    {
      kpi_irn: "",
      kpi_name: "",
      frequency: "",
      applicable: "",
      // weight: "",
      // target: "",
      isNew: true,     // new row
      isDirty: false,  // modified row
      isDeleted: false // deleted row (optional)
    }
  ]);

  useEffect(() => {

    loadGeneralMasters();

  }, []);

  const loadGeneralMasters = async () => {

    try {

      const response = await axios.get(`${BASE_URL}/api/ddl_Gen_Mst_Type`,
        { params: { type: 'CATG' } });

      if (response.data && response.data.length > 0) {
        setGenMasters(response.data);
      }

    } catch (err) {

      console.error("Error loading Team Members", err);

    }

  };

  const [filterApplicable, setFilterApplicable] = useState('0');
  //const [searchName, setSearchName] = useState("");
  //const count = processedRows.length;

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...kpiRows];
    updated[index][name] = value;

    // mark as dirty only if it's NOT a new row
    if (!updated[index].isNew) {
      updated[index].isDirty = true;
    }

    setKpiRows(updated);
  };

  const addRow = () => {
    setKpiRows([
      ...kpiRows,
      { kpi_irn: "", kpi_name: "", frequency: "", applicable: "", severity: "",
        //weight: "", target: "",
        isNew: true, isDirty: false,  isDeleted: false }
    ]);
  };

  const removeRow = (index) => {

    const updated = [...kpiRows];

    if (updated[index].isNew) {
      // New row → remove directly
      updated.splice(index, 1);
    } else {
      // Existing row → toggle delete
      updated[index].isDeleted = !updated[index].isDeleted;

      // Optional: if undo delete, also remove dirty flag
      if (!updated[index].isDeleted) {
        updated[index].isDirty = false;
      }
    }

    setKpiRows(updated);

  };

  const handleNew = () => {
    setIsEditable(true);
    setKpiRows([
      { kpi_irn: "", kpi_name: "", frequency: "", applicable: "", 
        //weight: "", target: "",
        isNew: true, isDirty: false,  isDeleted: false
       }
    ]);
  };

  const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      resetPage();
    }
  };

  const resetPage = () => {

      setKpiRows([
        { kpi_irn: "", kpi_name: "", frequency: "", applicable: "", 
          //weight: "", target: "",
          isNew: true, isDirty: false,  isDeleted: false
         }
      ]);
      setIsEditable(false);

   }

  const handleSave = async () => {

    let lv_err_msg = '';

    for (let i = 0; i < kpiRows.length; i++) {

      if (!kpiRows[i].kpi_name || kpiRows[i].kpi_name === '') {
        lv_err_msg = 'Please enter KPI Name at Row # ' + (i + 1);
        break;
      }

      if (kpiRows[i].frequency === '') {
        lv_err_msg = 'Please Select Frequency at Row # ' + (i + 1);
        break;
      }

      if (kpiRows[i].applicable === '') {
        lv_err_msg = 'Please Select Applicable For at Row # ' + (i + 1);
        break;
      }

    }

    if (lv_err_msg) {
      toast.error(lv_err_msg);
      return;
    }

    const isConfirmed = window.confirm("Sure you want to save KPI Masters ?");

    if (!isConfirmed) return;

    const newRows = kpiRows.filter(r => r.isNew && !r.isDeleted);
    const updatedRows = kpiRows.filter(r => r.isDirty && !r.isDeleted);
    const deletedRows = kpiRows.filter(r => r.isDeleted && !r.isNew);

    const payload = {
      insertedRows: newRows,
      updatedRows: updatedRows,
      deletedRows: deletedRows
    };

    try {

      const response = await axios.post(`${BASE_URL}/api/save_KPI_Master`, payload);

      if (response.data.message === '1') {
        setIsEditable(false);
        toast.success(`KPI saved successfully`);
        resetPage();
      } else {
        toast.error(`Error saving KPI`);
      }

    } catch (err) {
      console.error("Save error:", err);
      toast.error("Failed to save KPI. Please check input or contact Admin !");
    }

  };

  const handleEdit = async () => {

    const response = await axios.get(`${BASE_URL}/api/get_KPI_Masters`, { params: { p_Applicable: filterApplicable } });

    if (response.data && response.data.length > 0) {
      setIsEditable(true);
      setKpiRows(response.data);
    } else {
      toast.error("No Data to retrieve, please change Search Filter !");
    }

  };


  return (
    <Container fluid className="p-3">

      {/* Header Buttons */}
      <Card className="mb-3 p-3">

        <Row className="mt-1">
          <Col md={12}>

            <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap">

              <InputGroup style={{ width: "250px" }}>
                <InputGroup.Text style={{ width: "90px" }}>
                  Search
                </InputGroup.Text>
                <select
                  disabled={isEditable}
                  className="form-select"
                  value={filterApplicable}
                  onChange={(e) => setFilterApplicable(e.target.value)}
                >
                  <option value="0">--- All Categories ---</option>
                  {genMasters.map(gm => (
                    <option key={gm.gen_id} value={gm.gen_id}>{gm.gen_desc}</option>
                  ))}
                  {/* <option value="">All Data</option>
                <option value="T">Teaching Staff</option>
                <option value="A">Admin Staff</option>
                <option value="G">Grade-IV Staff</option>
                <option value="ALL">All Staff</option> */}
                </select>
              </InputGroup>

            <Button
              style={{ width: "130px" }}
              variant="primary"
              onClick={handleNew}
              disabled={isEditable}
            >
              New
            </Button>

            <Button
              style={{ width: "130px" }}
              variant="secondary"
              onClick={handleClear}
            >
              Clear
            </Button>

            <Button
              style={{ width: "130px" }}
              variant="primary"
              onClick={handleEdit}
              disabled={isEditable}
            >
              Edit
            </Button>

            <Button
              style={{ width: "130px" }}
              variant="success"
              onClick={handleSave}
              disabled={!isEditable}
            >
              Save
            </Button>

            </div>
          </Col>
        </Row>


      </Card>

      {/* KPI Table */}

      <Card className="p-3">

        <div style={{ minHeight: '220px' }} className="table-wrapper">

          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">

            <thead>
              <tr>
                <th style={{ width: "4%", textAlign: "center" }}>#</th>
                <th style={{ width: "60%" }}>KPI Name</th>
                <th style={{ width: "14%" }}>Frequency</th>
                <th style={{ width: "14%" }}>Applicable</th>
                {/* <th style={{ width: "10%", textAlign: "center" }}>Weight %</th>
                <th style={{ width: "12%", textAlign: "center" }}>Target</th> */}
                <th style={{ width: "6%" }}></th>
              </tr>
            </thead>

            <tbody>

              {kpiRows.map((row, index) => (

                <tr key={index}
                  style={{
                    backgroundColor: row.isDeleted ? "#f8d7da" : "",
                    textDecoration: row.isDeleted ? "line-through" : "",
                    opacity: row.isDeleted ? 0.7 : 1
                  }}>

                  <td style={{ textAlign: "center" }}>{index + 1}</td>

                  <td>
                    <input
                      type="text"
                      className="form-control"
                      name="kpi_name"
                      value={row.kpi_name}
                      disabled={!isEditable || row.isDeleted}
                      onChange={(e) => handleChange(index, e)}
                      //placeholder="Example: Syllabus Completion"
                    />
                  </td>

                  <td>
                    <select
                      className="form-select"
                      name="frequency"
                      value={row.frequency}
                      disabled={!isEditable || row.isDeleted}
                      onChange={(e) => handleChange(index, e)}
                    >
                      <option value="">--Select--</option>
                      <option value="D">Daily</option>
                      <option value="W">Weekly</option>
                      <option value="M">Monthly</option>
                      <option value="Q">Quarterly</option>
                      <option value="A">Annually</option>
                      <option value="H">As-And-When Basis</option>
                    </select>
                  </td>

                  <td>
                    <select
                      className="form-select"
                      name="applicable"
                      value={row.applicable}
                      disabled={!isEditable || row.isDeleted}
                      onChange={(e) => handleChange(index, e)}
                    >
                      <option value="">--Select--</option>
                      <option value="0">All Categories</option>
                      {/* <option value="A">Admin Staff</option>
                      <option value="G">Grade-IV Staff</option>
                      <option value="ALL">All Staff</option> */}
                      {genMasters.map(gm => (
                         <option key={gm.gen_id} value={gm.gen_id}>{gm.gen_desc}</option>
                      ))}
                    </select>
                  </td>

                  <td style={{ textAlign: "center" }}>
                    {kpiRows.length > 1 && (
                      <Button variant={row.isDeleted ? "secondary" : "danger"}
                        //variant="danger"
                        size="sm"
                        onClick={() => removeRow(index)}
                      >  {row.isDeleted ? "Undo" : "Delete"}
                      </Button>
                    )}
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

        <div className="d-flex justify-content-end mt-2">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip" style={{ backgroundColor: "#e9ecef" }}>Add Row</Tooltip>}
          >
            <Button
              variant="primary"
              onClick={addRow}
              disabled={!isEditable}
              style={{
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                padding: "0",
                fontSize: "30px"
              }}
            >
            +
          </Button>
          </OverlayTrigger>
        </div>

      </Card>

    </Container>
  );
};

export default KPI_Master;
